import { AnimatedSection, DarkCard, DarkMeshSection } from '@denqfabrik/landing-ui';
import { useTranslation } from '../../i18n';

export default function TokenSavingsSection() {
  const { t } = useTranslation();
  const { label, heading, headingHighlight, description, comparison, caption } = t.tokenSavings;

  return (
    <DarkMeshSection id="token-savings">
      {/* Heading */}
      <AnimatedSection>
        <div className="mx-auto mb-6 max-w-3xl text-center">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-teal-400">
            {label}
          </p>
          <h2 className="font-display text-[clamp(2.3rem,4.6vw,4.8rem)] font-medium leading-[1.08] tracking-[-0.028em] text-[#cfe0ff]">
            {heading && <>{heading}{' '}</>}
            <span className="bg-[linear-gradient(120deg,#4f8dff_10%,#62c7ff_62%,#61e3ce_100%)] bg-clip-text text-transparent">
              {headingHighlight}
            </span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-[clamp(1.05rem,1.35vw,1.35rem)] leading-[1.4] text-[var(--df-text-mid)]">
            {description}
          </p>
        </div>
      </AnimatedSection>

      {/* Comparison bars */}
      <div className="mx-auto mt-12 max-w-xl">
        <AnimatedSection delay={100}>
          <DarkCard>
            <div className="space-y-6 p-1 sm:p-2">
              {comparison.map((item, i) => (
                <div key={i}>
                  <div className="mb-2 flex items-baseline justify-between">
                    <span className={`text-sm font-semibold ${item.highlight ? 'text-teal-400' : 'text-slate-400'}`}>
                      {item.label}
                    </span>
                    <span className="text-xs text-slate-500">{item.tokens}</span>
                  </div>
                  <div className="h-4 overflow-hidden rounded-full bg-slate-800 sm:h-5">
                    <div
                      className={`h-full rounded-full transition-all duration-1000 ease-out ${
                        item.highlight
                          ? 'bg-gradient-to-r from-teal-400 to-emerald-400'
                          : 'bg-gradient-to-r from-slate-500 to-slate-600'
                      }`}
                      style={{ width: `${item.bar}%` }}
                    />
                  </div>
                </div>
              ))}

              {/* Caption */}
              <p className="pt-2 text-center text-xs text-slate-500 sm:text-sm">
                {caption}
              </p>
            </div>
          </DarkCard>
        </AnimatedSection>
      </div>
    </DarkMeshSection>
  );
}
